const lottiePlayer = () => ({
  init() {
    import('@lottiefiles/lottie-player');
  },

  showAssetBox() {
    this.$el.style.border = '1px solid green';
    const collectionsExplorerHeaderDecorator = this.$el.closest(
      '.collections-explorer__header-wrapper'
    );
    if (collectionsExplorerHeaderDecorator) {
      collectionsExplorerHeaderDecorator.style.zIndex = '1000';
    }
  },

  hideAssetBox() {
    this.$el.style.border = '';
    const collectionsExplorerHeaderDecorator = this.$el.closest(
      '.collections-explorer__header-wrapper'
    );
    if (collectionsExplorerHeaderDecorator) {
      collectionsExplorerHeaderDecorator.style.zIndex = '';
    }
  },
});

export default lottiePlayer;
